/**
 * Marianne brand constants.
 * Source of truth: logo (olive branch on purple) + editorial courthouse palette.
 */
export const BRAND = {
  LOGO_URL:
    "https://customer-assets.emergentagent.com/job_case-tribunal/artifacts/n0h0qk42_Product%20Icon%401x.png",
  name: "Marianne",
  tagline: "by Mahakali Tribunal",
  colors: {
    ink: "#2A0F5A",
    inkSoft: "#3D1F85",
    brand: "#7B56C9",
    brandSoft: "#9077D8",
    brandTint: "#EEE5FB",
    bronze: "#C5A059",
    ivory: "#FAFAF8",
    paper: "#FFFFFF",
    border: "#E8E3F0",
    muted: "#4A5568",
  },
};

export function Logo({ size = 28, className = "", rounded = false, alt = "Marianne" }) {
  return (
    <img
      src={BRAND.LOGO_URL}
      alt={alt}
      width={size}
      height={size}
      className={`${rounded ? "rounded-full" : ""} ${className}`}
      style={{ width: size, height: size, objectFit: "cover" }}
    />
  );
}
